/* src/app/header/header-account/header-account.component.scss */
div {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(94, 110, 130);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 5px;
}
div > span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  color: rgb(235, 241, 248);
}
/*# sourceMappingURL=header-account.component.css.map */
